module.exports = __webpack_public_path__ + "img/khal_img02.0772b6ed.svg";